export const playbackCommands = {
  PAUSE: "pause",
  PLAY: "play",
  STOP: "stop",
  SKIP: "skip",
  EMPTY_QUEUE: "emptyQueue",
  START: "start",
};

export const playingStates = {
  PLAY: "play",
  PAUSE: "pause",
  UNKNOWN: "unknown",
};

export const accessStates = {
  STOP: "stop",
  START: "start",
  UNKNOWN: "unknown",
};
